<common-dropdown [dropDownItems]="states" [selectedValue]="selectedState" (itemSelected)="stateChange($event)" [showSelect]="true"></common-dropdown>